export const MODULE = {
  authConsole: 'AUTH',
  saucerLog: 'saucer-logs',
  careposiConsole: 'CAREPOSI_CONSOLE'
};
